<template>
  <b-row>
    <b-col cols="12">
      <h2>
        Deals
      </h2>

      <div v-if="errors.length" class="alert alert-danger">
        <ul>
          <li v-for="error in errors" :key="error.msg">
            {{ error.msg }}
          </li>
        </ul>
      </div>

      <b-table striped hover :items="deals" :fields="fields">
        <template slot="actions" slot-scope="row">
          <b-btn
            size="sm"
            :to="{ name: 'DealDetail', params: { id: row.item._id } }"
            >Show</b-btn
          >
        </template>
      </b-table>
    </b-col>
  </b-row>
</template>

<script>
import API from '@/api';

export default {
  name: 'DealsList',
  data() {
    return {
      fields: {
        createdAt: { label: 'Request Timestamp', sortable: true },
        title: { label: 'Title', sortable: true },
        advertiser: { label: 'Advertiser', sortable: true },
        loc: {
          label: 'Location',
          formatter: value => {
            return value && value.length ? value[1] + ', ' + value[0] : '';
          },
          sortable: true
        },
        dealLoc: {
          label: 'Deal Location',
          formatter: value => {
            return value && value.length ? value[1] + ', ' + value[0] : '';
          },
          sortable: true
        },
        radius: { label: 'Radius', sortable: true },
        actions: { label: 'Action', sortable: true }
      },
      deals: [],
      errors: [],
      currentPage: 0,
      perPage: 10
    };
  },
  created() {
    this.reloadList();
  },
  methods: {
    reloadList() {
      this.errors = [];
      API.get('admin/deal/list').then(res => {
        if (res.status === 'ok') {
          this.deals = res.data.deals;
        } else {
          this.errors = res.errors;
        }
      });
    }
  }
};
</script>
